import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles.scss';

function Button({
  type, children, submit, onClick, className, disabled, isNext, isPrev,
}) {
  const classes = classNames([styles.button, styles[type], className]);
  const next = isNext ? styles.newProductButtonNext : null;
  const prev = isPrev ? styles.newProductButtonPrev : null;
  return (
    /* eslint-disable-next-line react/button-has-type */
    <button className={next || prev || classes} type={submit ? 'submit' : 'button'} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}

Button.propTypes = {
  type: PropTypes.oneOf(['default', 'primary', 'flat', 'transparent', 'link', 'primaryRole']),
  children: PropTypes.node,
  submit: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isNext: PropTypes.bool,
  isPrev: PropTypes.bool,
};

Button.defaultProps = {
  type: 'default',
  children: null,
  submit: false,
  onClick: null,
  className: null,
  disabled: false,
  isNext: false,
  isPrev: false,
};

export default Button;



// WEBPACK FOOTER //
// ./src/app/components/Button/index.js